import ProratedRentCalculator from '@zg-rentals/rg-widgets-rent-calc';
import React from 'react';

var ProratedRentCalculatorBlock = {
  Component: function Component(_ref) {
    var attrs = _ref.attrs;
    var itc = attrs.itc,
      t = attrs.t;
    var defaultValues = {
      itc: itc,
      t: t
    };
    return /*#__PURE__*/React.createElement(ProratedRentCalculator, defaultValues);
  },
  metadata: {
    version: '1.0',
    name: 'zg-rentals/rg-widgets-rent-calc',
    title: 'Prorated Rent Calculator',
    description: 'Calculate the prorated rent for a rental property.',
    icon: 'calculator',
    keywords: ['rental', 'prorate', 'calculator'],
    supports: {
      customClassName: false,
      html: false
    },
    category: 'calculators',
    attributes: {
      itc: {
        type: 'string'
      },
      t: {
        type: 'string'
      }
    }
  }
};
var ProratedRentCalculatorBlock$1 = ProratedRentCalculatorBlock;

export { ProratedRentCalculatorBlock$1 as default };
